import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/HyperGeoCalc/HyperGeoCalc.tsx");
